// Vendor
import $ from 'jquery';

// Elements
const $el = $('.modal');

// Modal popups
class Modal {

	constructor($el) {

		this.$el = $el;
		this.transitionDuration = 500;

		// init functions
		this.attachEvents();

		// set transition duration
		this.$el.css({
			animationDuration: this.transitionDuration / 1000 + 's'
		});

		// check for modal hash on startup
		this.openModal(window.location.hash);
	}

	attachEvents() {

		$(window).on('hashchange', () => {
			this.openModal(window.location.hash);
		});

		$('.modal-close-trigger').on('click', (event)=> {
			let id = $(event.target).closest('.modal').attr('id');
			this.closeModal( id );
		});

		$('.modal-scrollable').on('click', (event)=> {
			if ( $(event.target).hasClass('vertical-center') ) {
				let id = $(event.target).closest('.modal').attr('id');
				this.closeModal( id );
			}
		});
	}

	openModal( id ) {
		if ( $(id).length > 0 ) {
			$(id).addClass('active');
		}
	}

	closeModal( id ){
		// clear hash to _ to prevent scroll to top
		window.location.hash = '_';

		$('#'+id).addClass('hide');

		setTimeout(() => {
			$('#'+id).removeClass('active hide');
		}, this.transitionDuration);

	}
}

const _init = () => {
	if ($el.length) {
		$el.each((e, v) => {
			new Modal($(v));
		});
	}
};

_init();
